// TODO:: Esto posible mente va generar problemas con el tema de peticione a las q no tenga permisos
export const handleHttpError = (status: number) => {
   switch (status) {
      case 401:
         if (!window.location.href.includes('/auth/login'))
            window.location.pathname = '/auth/login';
         break;
      case 403:
         console.warn('Acceso denegado.');
         break;
      case 404:
         // window.location.pathname = '/error/404';
         break;
      case 429:
         console.warn('Demasiadas solicitudes. Por favor, intente más tarde.');
         break;
      // case 500:
      //    if (
      //       !window.location.href.includes('auth/register') &&
      //       !window.location.href.includes('auth/login') &&
      //       !window.location.href.includes('auth/forgot-password') &&
      //       !window.location.href.includes('auth/reset-password') &&
      //       !window.location.href.includes('auth/verify-email')
      //    )
      //       window.location.pathname = '/error/500';
      //    break;
      default:
         console.error(`Error HTTP no manejado: ${status}`);
         break;
   }
};
